import { render, staticRenderFns } from "./msgAlert.vue?vue&type=template&id=667248c5"
import script from "./msgAlert.vue?vue&type=script&lang=js"
export * from "./msgAlert.vue?vue&type=script&lang=js"
import style0 from "./msgAlert.vue?vue&type=style&index=0&id=667248c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports